import PanelFilter from '@/components/_core/ui/panels/panel-filter';
import { mapActions } from 'vuex';

export default {
  components: { PanelFilter },
  data() {
    return {
      showDialog    : false,
      loading       : false,
      tableActions  : [],
      filteredItems : [],
      tableOptions  : {},
      baseIcons     : {},
      tableItems    : [],
      tableHeader   : []
    };
  },
  mounted() {
    this.tableHeader = [
      { text: this.$t('_core.applicationStatus.table.application'), value: 'name' },
      { text: this.$t('_core.applicationStatus.table.status'), value: 'status' },
      { text: null, value: 'actions', sortable: false }
    ];
    this.baseIcons = {
      healthy   : 'mdi-access-point-check',
      unhealthy : 'mdi-access-point-remove',
      degraded  : 'mdi-access-point'
    };
  },
  watch: {
    showDialog(value) {
      if (value) {
        this.getAllStatus();
      }
    }
  },
  methods: {
    ...mapActions({
      actionGetAllStatus: '_core/applicationStatus/actionGetAllApplicationStatus'
    }),
    async getAllStatus() {
      this.loading = true;

      this.tableItems = await this.actionGetAllStatus();
      this.filteredItems = this.tableItems;

      this.loading = false;
    },
    search(value) {
      if (value) {
        this.loading = true;
        this.filteredItems = this.tableItems.filter(item =>
          item.name.toLowerCase().includes(value.toLowerCase())
        );
        this.loading = false;
      } else {
        this.filteredItems = this.tableItems;
      }
    }
  }
};
